import {Injectable} from '@angular/core';

@Injectable()
export class ConfigService {

    private baseUrl = 'https://api.luvienerji.com/';

    private config: Object = {
        env: 'dev',
        baseUrl: this.baseUrl,
        apiBaseUrl: this.baseUrl + '',
        loginUrl: this.baseUrl + 'oauth/token',
        clientId: 1,
        clientSecret: 'oDmvQ828hHMXr4iYHCitYloCBCqkrPFrGKEghEmB'
    };

    constructor() {}

    public get(key: string) {
        return this.config[key];
    }
}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/shared/services/config/config.service.ts